export function omitFromArray<T, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> {
	const result = structuredClone(obj);
	keys.forEach((key) => delete result[key]);
	return result;
}
